export default "__VITE_ASSET__DAL7AqGN__"